export default __webpack_public_path__ + "static/1867-b56c18e8fdc81f748b6eba5da61a8412.gif";